<template>
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_5296_31030)">
      <path
        d="M8.24992 16.5003C8.22125 16.5003 8.19325 16.4963 8.16525 16.489C8.09925 16.4723 1.58325 14.687 1.58325 8.61966V3.16699C1.58325 3.02699 1.66992 2.90299 1.80125 2.85432L8.13458 0.520988C8.20858 0.493655 8.29059 0.493655 8.36525 0.520988L14.6986 2.85432C14.8299 2.90299 14.9166 3.02699 14.9166 3.16699V8.61966C14.9166 14.6877 8.40058 16.4723 8.33458 16.4897C8.30658 16.4963 8.27858 16.5003 8.24992 16.5003ZM2.24992 3.39966V8.61966C2.24992 13.8743 7.48325 15.597 8.24992 15.821C9.01658 15.597 14.2499 13.8743 14.2499 8.61966V3.39966L8.24992 1.18966L2.24992 3.39966Z"
        fill="#48E4FF"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4.25 8.5C4.25 10.706 6.044 12.5 8.25 12.5C10.456 12.5 12.25 10.706 12.25 8.5C12.25 6.294 10.456 4.5 8.25 4.5C6.044 4.5 4.25 6.294 4.25 8.5ZM9.34741 10.0692C9.41275 10.1338 9.49808 10.1665 9.58341 10.1665C9.66875 10.1665 9.75408 10.1338 9.81941 10.0692C9.94941 9.93917 9.94941 9.72784 9.81941 9.59784L8.58341 8.36184V6.49984C8.58341 6.31584 8.43408 6.1665 8.25008 6.1665C8.06608 6.1665 7.91675 6.31584 7.91675 6.49984V8.49984C7.91675 8.5885 7.95208 8.67317 8.01408 8.73584L9.34741 10.0692Z"
        fill="#48E4FF"
      />
    </g>
    <defs>
      <clipPath id="clip0_5296_31030">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="translate(0.25 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
</template>

<script setup></script>
